(function() {
  'use strict';

  const btn = document.querySelector('.js-fixed-footer');
  if (!btn) return;

  btn.classList.remove('js-fixed-footer');
  let clone = document.createElement("div");
  clone.appendChild(btn.cloneNode(true));
  clone.classList.add('fixed-footer');
  
  document.body.appendChild(clone);

  const onScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const triggerY = 100;

    scrollY > triggerY ? clone.classList.add('fixed-footer--shown') : clone.classList.remove('fixed-footer--shown');
  };

  window.addEventListener('scroll', onScroll);
})();